import { AppointmentControllerApi, InvitePatient } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author Shrinivas Mandhare
 */
export const useInviteInstantAppointment = () =>
  useMutationWithLoading(
    async (params: InvitePatient & { xTENANTID?: string }) =>
      new AppointmentControllerApi(
        getConfigObject()
      ).invitePatientForInstantAppointment(params, params.xTENANTID)
  );
